import { Label } from '@/components/shadcn/ui/label';
import { Switch } from '@/components/shadcn/ui/switch';

import { useFieldContext } from './form';
import { getFieldError } from './get-field-error';

interface FormSwitchProps extends Omit<
  React.ComponentProps<typeof Switch>,
  'checked' | 'onCheckedChange'
> {
  label?: string;
  showErrorMessage?: boolean;
}

export function FormSwitch({
  label,
  showErrorMessage = true,
  ...props
}: FormSwitchProps) {
  const field = useFieldContext<boolean>();

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <Switch
          id={field.name}
          checked={field.state.value ?? false}
          onCheckedChange={(checked) => field.handleChange(checked)}
          {...props}
        />
        {label && (
          <Label htmlFor={field.name} className="cursor-pointer">
            {label}
          </Label>
        )}
      </div>
      {showErrorMessage && field.state.meta.errors.length > 0 && (
        <span className="text-destructive text-sm">
          {getFieldError(field.state.meta.errors[0])}
        </span>
      )}
    </div>
  );
}
